module.exports = __webpack_public_path__ + "img/type3.f36de36f.png";